import React from "react";
import { FilterBy, DisplayPagination, DisplayHeader, FontDropdown, JsonApiUrlInput, LanguageDropdown, PastShowsDropdown, PerPageInput, ThemeDropdown, UpcomingShowsDropdown } from "./components";
import DisplayCancelledShows from "./components/displaycancelledshows";
import { type FilterByTypes } from "./components/filterby";
import { type Font, fonts, type GetSetValueProp, type Theme } from "./models";
import CopyToClipboard from "components/Atoms/CopyToClipboard";

interface Props {
  displayHeader: GetSetValueProp<boolean>
  displayPagination: GetSetValueProp<boolean>
  locale: GetSetValueProp<string>
  font: GetSetValueProp<Font>
  perPage: GetSetValueProp<string>
  pastShowDays: GetSetValueProp<number>
  upcomingShowDays: GetSetValueProp<number>
  filterType: GetSetValueProp<FilterByTypes>
  includeCancelled: GetSetValueProp<boolean>
  setFilteredByIds: (ids: number[]) => void
  theme: GetSetValueProp<Theme>
  embedCode: string
  jsonUrl: string
}

const Wizard = (props: Props) => {
  const { displayPagination, displayHeader, locale, font, perPage, pastShowDays, upcomingShowDays, filterType, setFilteredByIds: setSelectedArtistIds, theme, includeCancelled } = props;

  return <>
    <div className="s1_panel">
      <div className="flex-column gap">
        <ThemeDropdown value={theme.value} setValue={theme.setValue} />
        <LanguageDropdown value={locale.value} setValue={locale.setValue} />
        <FontDropdown value={font.value} setValue={font.setValue} options={fonts} />
        <PerPageInput value={perPage.value} setValue={perPage.setValue} />
        <UpcomingShowsDropdown value={upcomingShowDays.value} setValue={upcomingShowDays.setValue} />
        <PastShowsDropdown value={pastShowDays.value} setValue={pastShowDays.setValue} />
        <DisplayPagination value={displayPagination.value} setValue={displayPagination.setValue} />
        <DisplayHeader value={displayHeader.value} setValue={displayHeader.setValue} />
        <FilterBy
          filterType={filterType}
          onFilterIdsChanged={setSelectedArtistIds}
        />
        <DisplayCancelledShows value={includeCancelled.value} setValue={includeCancelled.setValue} />
      </div>
    </div>

    <div className="s1_panel">
      <div className="margin-bottom">
        <div className="padding-bottom-mini s1_smaller">Embed code:</div>
        <CopyToClipboard value={props.embedCode} />
      </div>

      <div>
        <div className="padding-bottom-mini s1_smaller">API endpoint with JSON data:</div>
        <JsonApiUrlInput url={props.jsonUrl} />
      </div>
    </div>
  </>;
};

export default Wizard;